import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterValuesStrings } from '../pages/dashboard.page';
import { useAppSelector } from '../../../../src/store';

export interface DashboardFilterState {
	filters: FilterValuesStrings;
}

const defaultFilters: FilterValuesStrings = {
	districtIds: '',
	engagementTypes: '',
	duration: [null, null],
	schoolIds: '',
	programIds: '',
	serviceIds: '',
	providerIds: '',
	languages: '',
	engagementStatuses: '',
	//linkType: 'family-link',
};

export const initialState: DashboardFilterState = {
	filters: defaultFilters,
};

export const dashboardFilterSlice = createSlice({
	name: 'dashboardFilter',
	initialState,
	reducers: {
		setFilters(state: DashboardFilterState, action: PayloadAction<FilterValuesStrings>) {
			state.filters = action.payload;
		},
		clearFilters(state: DashboardFilterState) {
			state.filters = defaultFilters;
		},
	},
});

export const { setFilters, clearFilters } = dashboardFilterSlice.actions;

export const useDashboardFiltersSelector = () => useAppSelector((state) => state.dashboardFilter);
